





















































import { Component, Prop, Vue, Watch } from "vue-property-decorator";

import { ServerResult } from "@/core/http/server_result";
import { QueryBuilder } from "@/core/uql";
import { buildParentProductComboboxItems } from "./parentProductComboboxItems";

@Component
export default class ParentProductCombobox extends Vue {
  $db!: (queries: any[]) => Promise<ServerResult>;
  $q!: (queryName: string) => QueryBuilder;

  @Prop() value!: any;
  @Prop({ type: String }) position!: string;
  @Prop({ type: String, default: "Выберите родительский продукт" })
  placeholder!: string;

  localValue: any = null;
  selectedItemLabel: any = "";
  dropdownActive = false;

  items: any[] = [];
  itemsForDisplay: any[] = [];
  searchText: string = "";

  public mounted() {
    this.selectedItemLabel = this.placeholder;
    this.loadData();
  }

  public loadData() {
    const QNAME = "SELECT_PARENT_PRODUCT_COMBOBOX";
    console.debug("[FIX][ParentProductCombobox.loadData] START");

    this.$db([
      this.$q(QNAME)
        .raw("documents.list")
        .action({
          columns: {
            id: "products_types.id",
            name: "products_types.name",
            parent_id: "products_types.parent_id",
            record_type: "products_types.record_type"
          },
          from: "s:products_types",
          from_as: "products_types",
          page_size: 100000,
          order: [{ $asc: ["products_types.name"] }]
        })
    ])
      .then((result: ServerResult) => {
        const documents =
          (result.getOperation(QNAME).getContent() || {}).documents || [];
        this.items = buildParentProductComboboxItems(documents);
        console.debug("[FIX][ParentProductCombobox.loadData] SUCCESS", {
          documents: documents.length,
          items: this.items.length,
          groups: this.items.filter((i: any) => i.isGroup).length
        });

        this.onValueChange(this.value);
        this.updateDisplayList();
      })
      .catch((error: any) => {
        console.error("[FIX][ParentProductCombobox.loadData] ERROR", { error });
      });
  }

  @Watch("value")
  onValueChange(newVal: any) {
    this.localValue = newVal;

    if (this.localValue) {
      const selectedItem = this.items.find(
        (item: any) => !item.isGroup && item.id == this.localValue
      );
      this.selectedItemLabel = selectedItem
        ? selectedItem.label
        : this.placeholder;
    } else {
      this.selectedItemLabel = this.placeholder;
    }
  }

  updateValue(value: any) {
    if (value != null && String(value).indexOf("group-") === 0) {
      return;
    }
    console.debug("[ParentProductCombobox.updateValue]", { value });
    this.onValueChange(value);
    this.$emit("input", value);

    const selectedItem = this.items.find(
      (item: any) => !item.isGroup && item.id == this.localValue
    );
    this.$emit("input-object", selectedItem || null);
  }

  activeChange($event: any) {
    this.dropdownActive = $event;
    const width = this.$el.clientWidth;
    // @ts-ignore
    this.$children[0].$refs.dropdownMenu.children[0].style.width = width + "px";
    // @ts-ignore
    this.$children[0].$refs.dropdownMenu.children[0].children[0].style.width =
      width - 25 + "px";
    if (this.dropdownActive) {
      (this.$refs.searchInput as any).focus();
    }
  }

  @Watch("searchText")
  updateDisplayList() {
    const needle = (this.searchText || "").toLowerCase();
    if (!needle) {
      this.$set(this, "itemsForDisplay", this.items || []);
      return;
    }

    const filtered: any[] = [];
    let currentGroup: any = null;
    let groupHasMatch = false;

    (this.items || []).forEach((item: any) => {
      if (item.isGroup) {
        if (currentGroup && groupHasMatch) {
          // already pushed
        }
        currentGroup = item;
        groupHasMatch = false;
        return;
      }

      const match = (item.label || "").toLowerCase().includes(needle);
      if (match) {
        if (currentGroup && !groupHasMatch) {
          filtered.push(currentGroup);
          groupHasMatch = true;
        }
        filtered.push(item);
      }
    });

    this.$set(this, "itemsForDisplay", filtered);
  }
}
